module.exports = __webpack_public_path__ + "static/media/500021.8c54a277.svg";